<div [hidden]="true">
  <div id="interactionId">{{ interactionId }}</div>
  <div id="activityId-{{ error.endUrl }}" *ngFor="let error of activityIdList">
    {{ error.endUrl }} - {{ error.activityId }}
  </div>
  <div id="cartId">{{ cartId }}</div>
</div>
<ng-container *ngIf="!isDigitalFooterEnabled; else digitalFooter">
  <footer class="container-fluid" role="contentinfo">
    <div class="content" role="navigation">
      <p class="lead big-links" role="menu">
        <a
          *ngFor="let leftLink of footerLinks?.leftLinks; let ind = index"
          class="main"
          tmoAnchorDetect
          [link]="leftLink?.href"
          [isNewTab]="leftLink?.newTab"
          [seoHref]="true"
          (click)="onClick(leftLink?.href, leftLink?.newTab, leftLink?.name)"
          id="cta-default-189_{{ ind }}"
          >{{ leftLink?.name | uppercase }}</a
        >
        <span class="spacer" aria-hidden="true"></span>
        <a
          *ngFor="let secondaryLink of footerLinks?.secondaryLinks; let ind = index"
          class="secondary"
          tmoAnchorDetect
          [link]="secondaryLink?.href"
          [isNewTab]="secondaryLink?.newTab"
          [seoHref]="true"
          (click)="onClick(secondaryLink?.href, secondaryLink?.newTab, secondaryLink?.name)"
          role="menuitem"
          id="cta-default-190_{{ ind }}"
          >{{ secondaryLink?.name }}</a
        >
      </p>
      <div class="social" role="menu">
        <a
          *ngFor="let secondaryLink of footerLinks?.socialMediaLinks; let ind = index"
          tmoAnchorDetect
          [link]="secondaryLink?.href"
          [isNewTab]="secondaryLink?.newTab"
          [seoHref]="true"
          (click)="onClick(secondaryLink?.href, secondaryLink?.newTab, leftLink?.name)"
          title="{{ secondaryLink?.name }}"
          role="menuitem"
          id="cta-default-731_{{ ind }}"
        >
          <i [ngClass]="secondaryLink.cssClass" aria-hidden="true"></i>
        </a>
      </div>
      <p class="lead small-links" role="menu">
        <a
          *ngFor="let smallLink of footerLinks?.smallLinks; let ind = index"
          tmoAnchorDetect
          [link]="smallLink?.href"
          [isNewTab]="smallLink?.newTab"
          [seoHref]="true"
          (click)="onClick(smallLink?.href, smallLink?.newTab, smallLink?.name)"
          role="menuitem"
          [innerHtml]="smallLink?.name"
          id="cta-default-191_{{ ind }}"
        ></a>
      </p>
      <p class="legal">{{ footerData?.copyRightLink }}</p>
    </div>
  </footer>
</ng-container>
<ng-template #digitalFooter>
  <tmo-digital-footer
    *ngIf="footerLinks"
    [footerLinks]="footerLinks"
    [footerData]="footerData"
    (onMenuLinkClick)="onClick($event?.href, $event?.newTab, $event?.name)"
  ></tmo-digital-footer>
</ng-template>
<tmo-spinner [setDelay]="footerLinks" role="alert"></tmo-spinner>
